module.exports = __webpack_public_path__ + "img/blt-arrow03.a2c6bd84.svg";